import { createApiHandler } from './handler';

const appointmentRequests = {
  apiClient: null,
  path: '/admin/appointment-requests',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async approve(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/approve`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reject(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/reject`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async requestInfo(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/request-info`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async schedule(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/schedule`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async close(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/close`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default appointmentRequests;
